import React from 'react';

import cx from 'classnames';
import { Icon } from '../../../../ui-kit';

import { hexToRgba, isLightColor } from '../../utils';

import './styles/_play-button.scss';






const PlayButton = ({
  className,
  color = '#000',
  ...props
}) =>
<button
  type="button"
  className={cx('play-button', className)}
  style={{ backgroundColor: hexToRgba(color, 0.3) }}
  {...props}>

    <div
    className="play-button__inner"
    style={{ backgroundColor: hexToRgba(color, 0.9) }}>

      <Icon
      name="play"
      color={
      // Default icon color is dark
      color && isLightColor(color) ? undefined : 'white'}

      size={30}
      className="play-button__icon" />

    </div>
  </button>;


export default PlayButton;